import { Badge } from '../ui';
import type { BadgeTone } from '../ui';
import type { PlatformPostStatus, PostStatus } from '../../../shared/types';
import { platformPostStatusLabel, postStatusLabel } from '../../../shared/utils';
import { PLATFORM_POST_STATUS_TONE, POST_STATUS_TONE } from '../../lib/format';

const TONE_MAP: Record<'neutral' | 'info' | 'success' | 'warning' | 'danger', BadgeTone> = {
  neutral: 'neutral',
  info: 'info',
  success: 'success',
  warning: 'warning',
  danger: 'danger',
};

export function PostStatusBadge({ status }: { status: PostStatus }) {
  return <Badge tone={TONE_MAP[POST_STATUS_TONE[status]]} dot>{postStatusLabel(status)}</Badge>;
}

export function PlatformPostStatusBadge({ status }: { status: PlatformPostStatus }) {
  return (
    <Badge tone={TONE_MAP[PLATFORM_POST_STATUS_TONE[status]]} dot>
      {platformPostStatusLabel(status)}
    </Badge>
  );
}
